import React from "react";

import type { WearablesContinuityEntry } from "@/lib/wearables/wearables.routeCompanion";

import "./wearables-v2.css";

type Props = {
  entries: WearablesContinuityEntry[];
  onResumeEntry: (entry: WearablesContinuityEntry) => void;
};

export default function WearablesResumeTray({
  entries,
  onResumeEntry,
}: Props): JSX.Element {
  return (
    <aside className="st-wearables-v2-resume-tray">
      <h2 className="st-wearables-v2__tray-title">Recent continuity</h2>
      <div className="st-wearables-v2__tray-list">
        {entries.map((entry) => (
          <div key={entry.surface} className="st-wearables-v2__tray-item">
            <div>
              <div className="st-wearables-v2__tray-label">{entry.label}</div>
              <div className="st-wearables-v2__tray-meta">
                {entry.effectiveTrack} · {entry.status}
              </div>
            </div>
            <button
              type="button"
              className="st-wearables-v2__button"
              onClick={() => onResumeEntry(entry)}
            >
              Resume
            </button>
          </div>
        ))}
      </div>
    </aside>
  );
}